import React, { Component } from 'react'
import { Link } from 'react-router'

import classNames from './SortableBar.css'
import Icon from '../Icon'

export default class SortableBar extends Component {
  state = {
    menuOpen: false
  }
  toggleMenu = () => {
    this.setState({
      menuOpen: !this.state.menuOpen
    })
  }
  closeMenu = () => {
    this.setState({
      menuOpen: false
    })
  }
  render () {
    const { title, thumb, subtitle, onEdit, onRemove, onMute, muted, showHandle = true, titleLink, dotsMenu } = this.props
    let className = muted ? classNames.barMuted : classNames.bar
    if (this.props.className) {
      className += ' ' + this.props.className
    }
    const TitleComponent = titleLink ? Link : 'div'
    return (
      <div>
        <div className={className}>
          {thumb &&
            <div className={classNames.thumb} style={{ backgroundImage: `url(${thumb})` }} />
          }
          <TitleComponent className={classNames.title} to={titleLink}>
            {title}
            {subtitle &&
              <div className={classNames.subtitle}>
                {subtitle}
              </div>
            }
          </TitleComponent>
          {dotsMenu &&
            <button onClick={this.toggleMenu} className={classNames.button}>
              <Icon icon='dots' size={14} />
            </button>
          }
          {!dotsMenu && onEdit &&
            <button onClick={onEdit} className={classNames.button}>
              <Icon icon='edit' size={14} />
            </button>
          }
          {!dotsMenu && onRemove &&
            <button onClick={onRemove} className={classNames.button}>
              <Icon icon='trash' size={16} />
            </button>
          }
          {showHandle &&
            <button className={'handle ' + classNames.button}>
              <Icon icon='sort-handle' size={16} />
            </button>
          }
          {onMute &&
            <button onClick={onMute} className={classNames.muteButton}>
              {muted ? 'Unmute' : 'Mute'}
            </button>
          }
        </div>
        {dotsMenu &&
          <div className={this.state.menuOpen ? classNames.menuOpen : classNames.menu}>
            <button
              onClick={() => {
                this.closeMenu()
                onEdit()
              }}
              className={classNames.menuButton}>
              Modify
            </button>
            <button
              onClick={onRemove}
              className={classNames.menuButton}>
              Remove
            </button>
          </div>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/playlist/SortableBar.js